import * as React from 'react';

import { WithDeleted } from '@common/typescript/objects/WithDeleted';

export interface EditableListProps<T extends WithDeleted> {
	items: Array<T>;
	setItems: (items: Array<T>) => void;
	equalityChecker: (item: T, newItem: T) => boolean;
	renderItem: (item: T, removeItem: () => void) => JSX.Element | null;
	renderInput: (addNewItem: (item: T) => void) => JSX.Element;
}

export const EditableList = <T extends WithDeleted>(
	props: EditableListProps<T>,
) => {
	const {
		items,
		setItems,
		equalityChecker,
		renderItem,
		renderInput,
	} = props;

	return <>
		<div>
			{items.filter((item) => !item.deleted)
				.map((item) => renderItem(item, () => {
					const itemIndex = items.indexOf(item);

					const newArray = items.slice();

					if (item.id === -1) {
						newArray.splice(itemIndex, 1);
					} else {
						newArray.splice(itemIndex, 1, {
							...item,
							deleted: true,
						});
					}

					setItems(newArray);
				}))
			}
		</div>
		<div className="is-relative">
			{renderInput((newItem) => {
				const foundItem = items.filter((nextItem) => equalityChecker(nextItem, newItem as T))[0];

				if (!foundItem) {
					setItems([...items, newItem]);
				} else if (foundItem.deleted) {
					const itemIndex = items.indexOf(foundItem);
					const newArray = items.slice();

					newArray.splice(itemIndex, 1);

					newArray.push({
						...foundItem,
						deleted: false,
					});

					setItems(newArray);
				}
			})}
		</div>
	</>;
};
